<template>
  <canvas
    v-if="blurhash"
    ref="blurhashCanvasRef"
    class="BlurhashCanvas"
  />
</template>

<script lang="ts" setup>
import { decode } from "blurhash";
import { onMounted, useTemplateRef } from "vue";

const blurhash = defineModel<string>({
  required: true,
});

const blurhashCanvasRef = useTemplateRef<HTMLCanvasElement>("blurhashCanvasRef");

onMounted(() => {
  if (!blurhashCanvasRef.value) return;

  renderBlurhash(blurhashCanvasRef.value, blurhash.value);
});

function renderBlurhash (canvas: HTMLCanvasElement, blurhash: string) {
  const ctx = canvas.getContext("2d");
  if (!ctx) return;

  const width = canvas.width;
  const height = canvas.height;
  const pixels = decode(blurhash, width, height);
  const imageData = ctx.createImageData(width, height);

  imageData.data.set(pixels);
  ctx.putImageData(imageData, 0, 0);
}
</script>

<style lang="scss" scoped>
.BlurhashCanvas {
  display: block;
  object-fit: cover;
}
</style>
